/* eslint-disable consistent-return */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
/* eslint-disable brace-style */
/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-alert */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import moment from 'moment';
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { CamelCase } from '../../redux/helper/CamelCase';
import { GenerateDateFormat } from '../../redux/helper/DateConverter';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots';
import { DistributorActions } from '../../redux/actions';
import UpdateOfferSkeleton from '../../Components/Skeletons/UpdateOfferSkeleton';
import { useToast } from '../../context/ToastContext';

const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
};

function CreateBulkOffer(props) {
    const { isUpdate, GetDistributorList, DistributorList } = props;
    const history = useNavigate();

    const { update_id } = useParams();
    const [isOn, setIsOn] = useState(false);
    const [mainCategory, setmainCategory] = useState([]);
    const [criteriaCategory, setcriteriaCategory] = useState([]);
    const [CriteriasubCategory1, setCriteriasubCategory1] = useState([]);
    const [CriteriasubCategory2, setCriteriasubCategory2] = useState([]);
    const [concatSegment, setconcatSegment] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [productList, setproductList] = useState([]);
    const [categoryId, setcategoryId] = useState('');
    const [industry, setIndustry] = useState([]);
    const [isLoaading, setisLoaading] = useState(true);
    const [search, setSearch] = useState('');
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);

    const handleDependency = useCallback(
        async () => {
            const category = await distributorService.getOffersMainCategory();
            if (category.data.data.length > 0) {
                const arr = [];
                category.data.data.forEach((mng, i) => {
                    arr.push({
                        id: i, value: `${mng}`,
                    });
                });
                setisLoaading(false);
                setmainCategory(arr);
            }
        },
        [],
    );

    useEffect(() => {
        handleDependency();
    }, [handleDependency]);

    const initialState = {
        offer_code: '',
        offer_value: '',
        description: '',
        type: '',
        start_date: '',
        end_date: '',
    };
    const initialErrorState = {
        offer_code: '',
        offer_value: '',
        type: '',
        start_date: '',
        end_date: '',
    };
    const toggleState = {
        start_date: false,
        end_date: false,
        type: false,
    };
    const CriterionTogle = {
        main_category: '',
        category: '',
        subCategory1: '',
        subCategory2: '',
        subCategory1List: [],
        subCategory2List: [],
        categoryList: [],
        productStatus: 'No products available',
        products: [],
        selectedProducts: [],
    };
    const Initialcriteria = {
        offer_status: isOn ? 1 : 3,
        offer_parameter: 'quantity',
        minimum_quantity: '',
        maximum_quantity: '',
        minimum_value: '',
        maximum_value: '',
        trade_discount: '',
        additional_discount: '',
        discount_parameter: 0,
        trade_discount_error: '',
        additional_discount_error: '',
        maximum_discount: '',
        condition: 'OR',
        product_parameter: [CriterionTogle],
        FIXED_CASHBACK: '',
        FULFILMENT_CASHBACK: '',
    };

    const toggleSwitch = () => setIsOn(!isOn);
    const [state, setState] = useState(initialState);
    const [errorState, seterrorState] = useState(initialErrorState);
    const [toggle, settoggle] = useState(toggleState);
    const [criteria, setcriteria] = useState([Initialcriteria]);
    const [criteriaToggle, setcriteriaToggle] = useState(CriterionTogle);
    const [fetchCategories, setfetchCategories] = useState(false);
    const [loading, setloading] = useState(false);
    const [addFields, setAddFields] = useState(false);
    const [productsDropdown, setProductsDropdown] = useState(false);
    const [individualOffer, setIndividualOffer] = useState(false);
    const [searchValue, setsearchValue] = useState(['']);
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);
    const [selectedSearchIndex, setSelectedSearchIndex] = useState('');
    const [checkedBoxes, setCheckedBoxes] = useState(false);
    const [criteriaIndex, setCriteriaIndex] = useState('');
    const [productParameterIndex, setProductParameterIndex] = useState('');
    const [selectedEvent, setSelectedEvent] = useState('');
    const [viewDataResponse, setViewDataResponse] = useState([]);
    const [valueError, setValueError] = useState(['']);
    const [distributorIds, setDistributorsIds] = useState([]);
    const { showToast } = useToast();

    useEffect(() => {
        setAddFields(true);
        setCheckedBoxes(true);
    }, [addFields, checkedBoxes]);

    const handleDropdownStatus = () => {
        settoggle(toggleState);
    };

    const handleToggle = (key) => {
        handleDropdownStatus();
        const val = key === 'start_date' ? 'end_date' : 'start_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };
    const handleCriterion = () => {
        const CriteriaCopy = [...criteria];
        CriteriaCopy.push(Initialcriteria);
        setcriteria(CriteriaCopy);
        const temp = valueError;
        temp.push('');
        setValueError(temp);
    };

    const handleAddProductParameter = (index) => {
        const temp = [...criteria];
        const parameter = {
            main_category: '',
            category: '',
            subCategory1: '',
            subCategory2: '',
            productStatus: 'No products available',
            products: [],
            selectedProducts: [],
            subCategory1List: [],
            subCategory2List: [],
            categoryList: [],
        };
        temp[index].product_parameter.push(parameter);
        setcriteria(temp);
    };
    const RemoveCriterion = (id) => {
        const CriteriaDuplicate = [...criteria];
        CriteriaDuplicate.splice(id, 1);
        setcriteria(CriteriaDuplicate);
    };
    const RemoveProductParameter = (id, productparamterId) => {
        const temp = [...criteria];
        temp[id].product_parameter.splice(productparamterId, 1);
        setcriteria(temp);
    };
    const handleCondition = (idx, key) => {
        const CriteriaDuplicate = [...criteria];
        CriteriaDuplicate[idx].condition = key;
        setcriteria(CriteriaDuplicate);
    };
    const handleAddProduct = (index, parameterIndex, productSelected, event) => {
        const existingCriteria = [...criteria];
        if (event.target.checked === true) {
            existingCriteria[index].product_parameter[parameterIndex].selectedProducts.push({
                INVENTORY_ITEM_ID: productSelected.INVENTORY_ITEM_ID,
                CONCATENATED_SEGMENTS: productSelected.CONCATENATED_SEGMENTS,
                PRODUCT_NAME: productSelected?.MODEL_DESCRIPTION,
                PRODUCT_DESCRIPTION: productSelected?.DESCRIPTION,
            });
        } else {
            const selectedIndex = existingCriteria[index].product_parameter[parameterIndex].selectedProducts.indexOf({
                INVENTORY_ITEM_ID: productSelected.INVENTORY_ITEM_ID,
                PRODUCT_NAME: productSelected.MODEL_DESCRIPTION,
                PRODUCT_DESCRIPTION: productSelected?.DESCRIPTION,
                CONCATENATED_SEGMENTS: productSelected.CONCATENATED_SEGMENTS,

            });
            existingCriteria[index].product_parameter[parameterIndex].selectedProducts.splice(selectedIndex, 1);
        }
        existingCriteria[index].product_parameter[parameterIndex].productStatus = `${existingCriteria[index].product_parameter[parameterIndex].selectedProducts.length} selected`;
        setcriteria(existingCriteria);
    };

    const handleCheckedIndex = (index, parameterIndex, id) => {
        const existingCriteria = [...criteria];
        return existingCriteria[index].product_parameter[parameterIndex].selectedProducts.map((val) => val.INVENTORY_ITEM_ID).indexOf(id) > -1;
    };
    const handleCriteriatoggle = (i, key, index) => {
        setCriteriaIndex(criteriaIndex === '' ? i : '');
        setProductParameterIndex(productParameterIndex === '' ? index : '');
        setSelectedEvent(key);
        setcriteriaToggle(Initialcriteria);
        setcriteriaToggle((prevState) => ({
            ...prevState,
            [key]: criteriaToggle[key] === '' ? i : '',
        }));
        setsubmitSelected(false);
    };

    const fetchProduct = async (segments, i, index) => {
        const paylaod = {
            concat_segments: segments,
        };

        const getproducts = await distributorService.getProductsListBySegments(paylaod);
        if (!getproducts.error && getproducts.data.data.success_status) {
            if (getproducts.data.data.data.length > 0) {
                criteria[i].product_parameter[index].productStatus = '0 selected';
            }
            setproductList(getproducts.data.data.data);
            criteria[i].product_parameter[index].products = getproducts.data.data.data;
            setcategoryId(getproducts.data.data.CATEGORY_ID);
            setcriteria(criteria);
        } else {
            SetErrorMessage(getproducts.message);
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
            setloading(false);
        }
    };

    const categorySearchHandler = (value) => {
        if (search === '') {
            return value;
        } if ((value.value).toLowerCase().includes(search.toLowerCase())) {
            return value;
        }
    };

    const productSearchHandler = (product) => {
        if (search === '') {
            return product;
        } if (product?.DESCRIPTION.toLowerCase().includes(search.toLowerCase()) || product.CONCATENATED_SEGMENTS.toLowerCase().includes(search.toLowerCase())) {
            return product;
        }
    };

    const handleCategories = async (mainCategorySelected, i, index, type, sub1, sub2, sub3, element, editFlag) => {
        let response;
        const seg = concatSegment;
        setSearch('');
        const CriteriaDuplicate = [...criteria];
        switch (type) {
        case 'main_category':
            setproductList([]);
            response = await distributorService.getSku({ SEGMENT1: mainCategorySelected });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, ele) => {
                    item.id = `main_category--${ele}`;
                    item.SEGMENT1 = item.name;
                    item.value = item.name;
                    item.main_category = mainCategorySelected;
                    arr.push(item);
                });
                setconcatSegment(mainCategorySelected);
                setcriteriaCategory(arr);
                CriteriaDuplicate[i].product_parameter[index].categoryList = arr;
                // CriteriaDuplicate[sub1].CATEGORY_ID = response.data?.data[0]?.CATEGORY_ID;
                setcriteria(CriteriaDuplicate);
            } else {
                alert('Something went wrong');
            }
            break;
        case 'category':
            response = await distributorService.getSku({ SEGMENT2: sub1 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, ele) => {
                    item.id = `category--${ele}`;
                    item.SEGMENT2 = item.name;
                    item.value = item.name;
                    item.category = item.name;
                    arr.push(item);
                });
                setCriteriasubCategory1(arr);
                // const CriteriaDuplicate = [...criteria];
                if (!editFlag) {
                    CriteriaDuplicate[i].product_parameter[index].subCategory1List = arr;
                    setcriteria(CriteriaDuplicate);
                    setconcatSegment(`${criteria[i].product_parameter[index].main_category}.${criteria[i].product_parameter[index].category}`);
                } else {
                    setconcatSegment(`${mainCategory}.${sub1}`);
                    element['subCategory1List'] = arr;
                }
                setcategoryId(response.data.data[0].CATEGORY_ID);
            } else {
                alert('Something went wrong');
            }
            break;
        case 'subCategory1':
            response = await distributorService.getSku({ SEGMENT3: sub2 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, ele) => {
                    if (item !== null) {
                        item.id = `subcategory--${ele}`;
                        item.SEGMENT3 = item.name;
                        item.value = item.name;
                        item.subCategory1 = item.name;
                        arr.push(item);
                    }
                });
                if (!editFlag) {
                    if (arr[0].name !== null) {
                        setCriteriasubCategory2(arr);
                        // const CriteriaDuplicate = [...criteria];
                        CriteriaDuplicate[i].product_parameter[index].subCategory2List = arr;
                        setcriteria(CriteriaDuplicate);
                        setconcatSegment(`${concatSegment}.${sub2}`);
                    } else {
                        fetchProduct(`${criteria[i].product_parameter[index].main_category}.${criteria[i].product_parameter[index].category}.${criteria[i].product_parameter[index].subCategory1}.`, i, index);
                    }
                } else {
                    if (arr[0].name !== null) {
                        setCriteriasubCategory2(arr);
                        // const CriteriaDuplicate = [...criteria];
                        element['subCategory2List'] = arr;
                        // setcriteria(CriteriaDuplicate);
                        setconcatSegment(`${mainCategory}.${sub1}.${sub2}.`);
                    } else {
                        fetchProduct(`${mainCategory}.${sub1}.${sub2}.`, i, index);
                    }
                }
            } else {
                alert('Something went wrong');
            }
            break;
        case 'subCategory2':
            response = await distributorService.getSku({ SEGMENT4: sub3 });
            if (!response.error && response.data.success_status) {
                const arr = [];
                const itemsArr = [];
                response.data.data.forEach((val) => {
                    itemsArr.push({ name: val });
                });
                itemsArr.forEach((item, ele) => {
                    if (item !== null) {
                        item.id = `subcategory2--${ele}`;
                        item.SEGMENT4 = item.name;
                        item.value = item.name;
                        item.subCategory2 = item.name;
                        arr.push(item);
                    }
                });

                fetchProduct(`${criteria[i].product_parameter[index].main_category}.${criteria[i].product_parameter[index].category}.${criteria[i].product_parameter[index].subCategory1}.${criteria[i].product_parameter[index].subCategory2}`, i, index);
            } else {
                alert('Something went wrong');
            }
            break;

        default: break;
        }
    };

    const handleSelectCategories = (type, i, index, value) => {
        let CriteriaDuplicate = [];
        CriteriaDuplicate = [...criteria];
        if (type !== 'products') {
            CriteriaDuplicate[i].product_parameter[index][type] = value;
        }
        setfetchCategories(!fetchCategories);
        switch (type) {
        case 'main_category':
            handleCategories(value, i, index, type, '', false);
            CriteriaDuplicate[i].product_parameter[index].category = '';
            CriteriaDuplicate[i].product_parameter[index].subCategory1 = '';
            CriteriaDuplicate[i].product_parameter[index].subCategory2 = '';
            CriteriaDuplicate[i].product_parameter[index].categoryList = [];
            CriteriaDuplicate[i].product_parameter[index].subCategory1List = [];
            CriteriaDuplicate[i].product_parameter[index].subCategory2List = [];
            CriteriaDuplicate[i].product_parameter[index].products = [];
            CriteriaDuplicate[i].product_parameter[index].selectedProducts = [];
            CriteriaDuplicate[i].product_parameter[index].productStatus = 'No products available';
            setcriteria(CriteriaDuplicate);
            setSelectedEvent('');
            break;
        case 'category':
            handleCategories(mainCategory[i], i, index, type, value, '', false);
            CriteriaDuplicate[i].product_parameter[index].subCategory1 = '';
            CriteriaDuplicate[i].product_parameter[index].subCategory2 = '';
            CriteriaDuplicate[i].product_parameter[index].subCategory1List = [];
            CriteriaDuplicate[i].product_parameter[index].subCategory2List = [];
            setCriteriasubCategory1([]);
            setCriteriasubCategory2([]);
            CriteriaDuplicate[i].product_parameter[index].products = [];
            CriteriaDuplicate[i].product_parameter[index].selectedProducts = [];
            CriteriaDuplicate[i].product_parameter[index].productStatus = 'No products available';
            setcriteria(CriteriaDuplicate);
            // setproductList([]);
            setcriteria(CriteriaDuplicate);
            setSelectedEvent('');
            break;
        case 'subCategory1':
            handleCategories(criteria[i].product_parameter[index].main_category, i, index, type, criteria[i].product_parameter[index].category, criteria[i].product_parameter[index].subCategory1, value, '', false);
            CriteriaDuplicate[i].product_parameter[index].subCategory2 = '';
            CriteriaDuplicate[i].product_parameter[index].subCategory2List = [];
            setcriteria(CriteriaDuplicate);
            setCriteriasubCategory2([]);
            CriteriaDuplicate[i].product_parameter[index].products = [];
            CriteriaDuplicate[i].product_parameter[index].selectedProducts = [];
            CriteriaDuplicate[i].product_parameter[index].productStatus = 'No products available';
            setcriteria(CriteriaDuplicate);
            setSelectedEvent('');
            break;
        case 'subCategory2':
            handleCategories(criteria[i].product_parameter[index].main_category, i, index, 'subCategory2', criteria[i].product_parameter[index].category, criteria[i].product_parameter[index].subCategory1, value, '', false);
            setconcatSegment(`${concatSegment}.${value}`);
            CriteriaDuplicate[i].product_parameter[index].products = [];
            CriteriaDuplicate[i].product_parameter[index].selectedProducts = [];
            CriteriaDuplicate[i].product_parameter[index].productStatus = 'No products available';
            setcriteria(CriteriaDuplicate);
            setSelectedEvent('');
            break;
        case 'products':
            setCriteriaIndex(i);
            setProductParameterIndex(index);
            setSelectedEvent('products');
            // handleCategories(criteria[i].product_parameter[index].main_category, i, index, 'products', criteria[i].product_parameter[index].category, criteria[i].product_parameter[index].subCategory1, criteria[i].product_parameter[index].subCategory2);
            if (CriteriaDuplicate[i].product_parameter[index].products === undefined) {
                CriteriaDuplicate[i].product_parameter[index].products = [];
                CriteriaDuplicate[i].product_parameter[index].selectedProducts = [];
                CriteriaDuplicate[i].product_parameter[index].productStatus = 'No products available';
                setcriteria(CriteriaDuplicate);
                // setproductList([]);
            }
            // CriteriaDuplicate[i].product_parameter[index].products = [];
            // setcriteria(CriteriaDuplicate);
            // setproductList([]);
            break;
        default: break;
        }
        setcriteriaToggle(Initialcriteria);
    };

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setState((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };
    const InputCriteriaChange = (e, index) => {
        const criteriaCopy = [...criteria];
        e.preventDefault();
        const { id, value } = e.target;
        if (criteriaCopy[index].discount_parameter === 1 && (id === 'trade_discount' || id === 'additional_discount')) {
            if (value >= 99) {
                criteriaCopy[i][id === 'trade_discount' ? 'trade_discount_error' : 'additional_discount_error'] = 'Please apply the valid discount';
            }
        }
        if (id === 'maximum_quantity' || id === 'maximum_value') {
            const temp = valueError;
            valueError[index] = '';
        }
        criteriaCopy[index][id] = value;

        setcriteria(criteriaCopy);
    };
    const handleDate = (val, key) => {
        if (key === 'start_date') {
            setState((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        setState((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    const validate = () => {
        let isvalid = true;
        Object.keys(state).forEach((key) => {
            switch (key) {
            case 'offer_code':
            case 'offer_value':
            case 'type':
            case 'start_date':
            case 'end_date':
                if (state[key] === '') {
                    seterrorState((prevState) => ({
                        ...prevState,
                        [key]: `${key} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };
    const Criteriavalidate = () => {
        let isvalid = true;
        criteria.forEach((key, valIndex) => {
            if (key.trade_discount === '' || key.additional_discount === '' || key.FIXED_CASHBACK === '' || key.FULFILMENT_CASHBACK === '') {
                isvalid = false;
            }
            key.product_parameter.forEach((key1, valIndex1) => {
                if (key1.main_category === '') {
                    isvalid = false;
                }
            });
            const maxquantity = key.maximum_quantity;
            const minquantity = key.minimum_quantity;
            const maxvalue = key.maximum_value;
            const minvalue = key.minimum_value;
            if (parseInt(maxquantity, 10) < parseInt(minquantity, 10)) {
                isvalid = false;
                const temp = valueError;
                temp[valIndex] = 'Maximum quantity should be greater than Minimum quantity';
                setValueError(temp);
            }
            if (parseInt(maxvalue, 10) < parseInt(minvalue, 10)) {
                isvalid = false;
                const temp = valueError;
                temp[valIndex] = 'Maximum value should be greater than Minimum value';
                setValueError(temp);
            }
        });
        return isvalid;
    };

    const handleChangeToggle = (i, value, e) => {
        const temp = [...criteria];
        switch (e) {
        case 'quantity':
            temp[i].offer_parameter = e;
            temp[i].maximum_value = '';
            temp[i].minimum_value = '';
            const dup = valueError;
            dup[i] = '';
            // setToggleOfferParamters(!toggleOfferParameters);
            break;
        case 'value':
            temp[i].offer_parameter = e;
            temp[i].maximum_quantity = '';
            temp[i].minimum_quantity = '';
            // setToggleOfferParamters(!toggleOfferParameters);
            const dup1 = valueError;
            dup1[i] = '';
            break;
        case 'discount_parameter':
            const val = value;
            if (value === val) {
                temp[i].trade_discount = '';
                temp[i].additional_discount = '';
            }
            temp[i].discount_parameter = value;
            break;
        default: break;
        }
    };

    const handleSegment = (item) => {
        let final = '';
        if (item.main_category !== '') {
            final = `${item.main_category}`;
        }
        if (item.category !== '') {
            final += `.${item.category}`;
        }
        if (item.subCategory1 !== '') {
            final += `.${item.subCategory1}`;
        }
        if (item.subCategory2 !== '') {
            final += `.${item.subCategory2}`;
        }
        return final;
    };

    const handleProductParameterPayload = (parameter) => {
        const arr = [];
        parameter.forEach((item, i) => {
            const init = {
                MAIN_CATEGORY: item.main_category,
                SEGMENT1: item.main_category,
                SEGMENT2: item.category,
                SEGMENT3: item.subCategory1,
                SEGMENT4: item.subCategory2,
                CATEGORY_CONCAT_SEGS: handleSegment(item),
                products: item.selectedProducts,
            };
            arr.push(init);
        });
        return arr;
    };

    const handleCriterionPayload = () => {
        const arr = [];
        criteria.forEach((item, i) => {
            const init = {
                OFFER_PARAMETER: item.offer_parameter,
                MIN_QUANTITY: item.minimum_quantity,
                MIN_VALUE: item.minimum_value,
                TRADE_DISCOUNT: item.trade_discount,
                ADDITIONAL_DISCOUNT: item.additional_discount,
                FIXED_CASHBACK: item.FIXED_CASHBACK,
                FULFILMENT_CASHBACK: item.FULFILMENT_CASHBACK,
                MAX_DISCOUNT: item.maximum_discount,
                is_value: item.offer_parameter === 'value',
                is_quantity: item.offer_parameter === 'quantity',
                discount_parameter: 1,
                or_combination: item.condition === 'OR',
                and_combination: item.condition === 'AND',
                product_parameters: handleProductParameterPayload(item.product_parameter),
            };
            arr.push(init);
        });
        return arr;
    };

    const handleCreateDeal = async (e, key) => {
        if (key === 'create') {
            e.preventDefault();
            seterrorState({
                offer_code: '',
                offer_value: '',
                type: '',
                start_date: '',
                end_date: '',
            });
            setloading(true);
            setsubmitSelected(true);
            if (!Criteriavalidate() || !validate()) {
                setloading(false);
                return;
            }
            const payload = {
                offer_code: isUpdate ? undefined : state.offer_code,
                offer_type: state.offer_type,
                offer_value: state.offer_value,
                description: state.description,
                start_date: moment(state.start_date).format('YYYY-MM-DD'),
                end_date: moment(state.end_date).format('YYYY-MM-DD'),
                industrial_pocket: state.type,
                offer_status: isOn ? '1' : '3',
                product_criterion: handleCriterionPayload(),
            };
            let create;
            if (isUpdate) {
                create = await distributorService.UpdateBulkOffer(payload, state.offer_code);
            } else {
                create = await distributorService.createBulkOffer(payload);
            }

            if (!create.error && create.data.success_status) {
                // SetSuccessMessage(create.data.message);
                showToast(create?.data?.message);
                history('/bulk-offers');
                setloading(false);
            } else {
                showToast(create?.message, '#ED1C24');
                setloading(false);
            }
        }
    };
    // Update
    const getDetails = useCallback(
        async () => {
            const OfferDetals = await distributorService.ViewBulkOffer(update_id.replace(/-/g, '/'));
            if (!OfferDetals.error && OfferDetals.data.success_status) {
                setViewDataResponse(OfferDetals.data.data);
                const OfferDetail = OfferDetals.data.data;
                setState({
                    offer_code: OfferDetail.offer_code,
                    offer_value: OfferDetail.offer_value,
                    description: OfferDetail.description,
                    type: OfferDetail.industrial_pocket,
                    start_date: new Date(OfferDetail.start_date),
                    end_date: new Date(OfferDetail.end_date),
                });
                const arr = [];
                OfferDetail.product_criterion.forEach((item, i = 0) => {
                    const initstate = {
                        offer_parameter: item.OFFER_PARAMETER,
                        discount_parameter: (parseInt(item.discount_parameter, 10)),
                        minimum_quantity: item.MIN_QUANTITY,
                        minimum_value: item.MIN_VALUE,
                        trade_discount: item.TRADE_DISCOUNT,
                        additional_discount: item.ADDITIONAL_DISCOUNT,
                        maximum_discount: item?.MAX_DISCOUNT,
                        product_parameter: item.product_parameters,
                        condition: item.and_combination && 'AND' || item.or_combination && 'OR',
                        ADDITIONAL_DISCOUNT: item.additional_discount,
                        FIXED_CASHBACK: item.FIXED_CASHBACK,

                    };
                    initstate.product_parameter.forEach((ele, index = 0) => {
                        ele['main_category'] = ele.SEGMENT1;
                        ele['category'] = ele.SEGMENT2;
                        ele['subCategory1'] = ele.SEGMENT3;
                        ele['subCategory2'] = ele.SEGMENT4;
                        ele['selectedProducts'] = ele.products;
                        ele['productStatus'] = `${ele.products.length} selected`;
                        if (ele.SEGMENT2 !== '') {
                            // handleCategories(ele.SEGMENT1, i, index, 'main_category', '', '', '');
                            setproductList([]);
                            distributorService.getSku({ SEGMENT1: ele.SEGMENT1 }).then((response) => {
                                if (!response.error && response.data.success_status) {
                                    const arr1 = [];
                                    const itemsArr = [];
                                    response.data.data.forEach((val) => {
                                        itemsArr.push({ name: val });
                                    });
                                    itemsArr.forEach((item1, ele1) => {
                                        item1.id = `main_category--${ele1}`;
                                        item1.SEGMENT1 = item1.name;
                                        item1.value = item1.name;
                                        item1.main_category = ele1.SEGMENT1;
                                        arr1.push(item1);
                                    });
                                    setconcatSegment(ele.SEGMENT1);
                                    setcriteriaCategory(arr1);
                                    ele['categoryList'] = arr1;
                                    // CriteriaDuplicate[sub1].CATEGORY_ID = response.data?.data[0]?.CATEGORY_ID;
                                    // setcriteria(CriteriaDuplicate);
                                }
                            });
                        }
                        if (ele.SEGMENT3 !== '') {
                            handleCategories(item.SEGMENT1, i, index, 'category', ele.SEGMENT2, '', '', ele, true);
                        }
                        if (ele.SEGMENT4 !== '') {
                            handleCategories(item.SEGMENT1, i, index, 'subCategory1', '', ele.SEGMENT3, '', ele, true);
                        }
                    });
                    arr.push(initstate);
                });
                setcriteria(arr);
                setIsOn(OfferDetail.offer_status === '1' && true);
                setisLoaading(false);
            }
        },
        [update_id],
    );

    const getIndustry = useCallback(
        async () => {
            const Industry = await distributorService.getAllIndusty();
            if (!Industry.error && Industry.data.success_status) {
                setIndustry(Industry.data.data);
            }
        },
        [],
    );

    const handleIndividualOffer = () => {
        setIndividualOffer(!individualOffer);
        const temp = state;
        temp.indivisual = true;
    };

    useEffect(() => {
        if (isUpdate) {
            getDetails();
        }
        getIndustry();
    }, [getDetails]);

    return (
        <div className="relative">
            <div className="flex items-center">
                <Link to="/bulk-offers">
                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                </Link>
                <h5 className="text-xs4 font-normal text-[#555259]">{isUpdate ? 'Update Offer' : 'Create New Offer'}</h5>
            </div>
            <div className="flex justify-end">
                <div className="flex justify-center items-end flex-col">
                    <span className="text-xs2 font-semibold text-[#808285] mb-1.5 pr-[37px]">
                        Status

                    </span>
                    <div className="flex items-center">
                        <div className="switch" data-isOn={isOn} onClick={toggleSwitch}>
                            <motion.div className="handle" layout transition={spring} />
                        </div>
                        <span className="text-[#ffff]">.</span>
                        {' '}
                        <div>
                            {isOn ? (
                                <div>
                                    {' '}
                                    {' '}
                                    Active
                                </div>
                            ) : (
                                <div>
                                    {' '}
                                    {' '}
                                    Draft
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            {isLoaading ? <UpdateOfferSkeleton />
                : (
                    <>
                        <div className="flex mt-3.5 -mx-2">
                            <div className="px-2 w-1/3">
                                <div className="relative">
                                    <input
                                        onChange={(e) => {
                                            InputChange(e);
                                            setsubmitSelected(false);
                                        }}
                                        type="text"
                                        id="offer_code"
                                        disabled={isUpdate}
                                        value={state.offer_code}
                                        onKeyDown={(e) => ['?', '%', '&'].includes(e.key) && e.preventDefault()}
                                        className={`h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && state.offer_code === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="offer_code" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        Offer Code
                                        {' '}
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    {submitSelected && state.offer_code === '' ? <span className="text-s font-light text-[#ED1C24]">Offer code is required</span> : ''}

                                </div>
                            </div>
                            <div className="px-2 w-1/3">
                                <div className="relative">
                                    <input
                                        type="text"
                                        onChange={(e) => InputChange(e)}
                                        id="offer_value"
                                        value={state.offer_value}
                                        onFocus={() => setsubmitSelected(false)}
                                        className={`h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && state.offer_value === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                                    />
                                    <label htmlFor="offer_value" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        Bulk Offer Tag
                                        {' '}
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    {submitSelected && state.offer_value === '' && <span className="text-s font-light text-[#ED1C24]">Bulk Offer Tag is required</span>}

                                </div>
                            </div>
                            <div className="px-2 w-1/3">
                                <div className="dropdown relative">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            handleToggle('type');
                                            setsubmitSelected(false);
                                        }}
                                        id="HIP"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className={`dropdown-to text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && state.type === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                                    >
                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                            Type
                                            {' '}
                                            <span className="text-[#ED1C24]">*</span>
                                        </p>
                                        <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                        {state.type}
                                    </button>
                                    {submitSelected && state.type === '' && <span className="text-s font-light text-[#ED1C24]">Type is required</span>}

                                    <ul className={`dropdown-menu overflow-auto w-full absolute ${toggle.type ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="HIP" style={{ borderRadius: '8px' }}>
                                        {industry && industry.map((ind, indIndex) => (
                                            <li
                                                key={`ind${indIndex}`}
                                                className="pl-3.5 w-full pt-3 bg-[#ffffff]"
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        type: ind.LOOKUP_CODE,
                                                    }));
                                                    settoggle((prevState) => ({
                                                        ...prevState,
                                                        type: false,
                                                    }));
                                                }}
                                            >
                                                <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)">
                                                    {' '}
                                                    {ind.LOOKUP_CODE}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="mt-5 relative">
                            <label htmlFor="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Description</label>
                            <textarea
                                name="description"
                                id="description"
                                value={state.description}
                                onChange={(e) => InputChange(e)}
                                className="w-full resize-none h-[74px] rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-4 py-3.5"
                            />
                        </div>
                        <div className="mt-5 flex -mx-2">
                            <div className="px-2 w-1/3">
                                <div className="relative">
                                    <label htmlFor="offercode12" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        Start Date
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    <img src="/images/Iconawesome-calendar-alt.svg" alt="icon" className="absolute top-4 right-5 cursor-pointer" onClick={() => handleToggle('start_date')} />
                                    <input
                                        datepicker
                                        value={state.start_date !== '' ? GenerateDateFormat(state.start_date) : ''}
                                        datepicker-autohide
                                        type="text"
                                        onClick={() => {
                                            handleToggle('start_date');
                                            setsubmitSelected(false);
                                        }}
                                        className={`cursor-pointer text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && state.start_date === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                                    />
                                </div>
                                <div>
                                    {toggle.start_date && <Calendar minDate={moment(new Date()).toDate()} value={state.start_date} onChange={(val) => handleDate(val, 'start_date')} />}
                                </div>
                                {submitSelected && state.start_date === '' && <span className="text-s font-light text-[#ED1C24]">Start Date is required</span>}

                            </div>
                            <div className="px-2 w-1/3">
                                <div className="relative">
                                    <label htmlFor="offercode11" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        End Date
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                    <img
                                        src="/images/Iconawesome-calendar-alt.svg"
                                        alt="icon"
                                        className="absolute top-4 right-5 cursor-pointer"
                                        onClick={() => handleToggle('end_date')}
                                    />
                                    <input
                                        datepicker
                                        onClick={() => {
                                            handleToggle('end_date');
                                            setsubmitSelected(false);
                                        }}
                                        datepicker-autohide
                                        type="text"
                                        value={state.end_date !== '' ? GenerateDateFormat(state.end_date) : ''}
                                        className={`cursor-pointer text-left h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && state.end_date === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5`}
                                    />
                                </div>
                                <div>
                                    {toggle.end_date && <Calendar value={state.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(state.start_date).toDate()} />}
                                </div>
                                {submitSelected && state.end_date === '' && <span className="text-s font-light text-[#ED1C24]">End Date is required</span>}

                            </div>
                        </div>
                        <div className="mt-8 w-full">
                            <form onSubmit={(e) => handleCreateDeal(e, 'create')}>

                                <h5 className="text-sm font-bold text-[#090406]">Criteria</h5>
                                <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 pt-8 w-full">
                                    {(criteria.length !== undefined && criteria.length !== 0) && criteria.map((item, i) => (
                                        (item.product_parameter !== undefined && item.product_parameter.length !== 0)
                                        && (
                                            <div className="creation2">
                                                <div className={`pb-1.5 flex justify-between  px-[22px] ${i !== 0 ? 'pt-8' : ''}`}>
                                                    {i === 0 ? (
                                                        <p className="text-sm font-bold text-[#090406]">Criterion</p>
                                                    ) : (
                                                        <p className="text-sm font-bold text-[#090406]">
                                                            Criterion
                                                            {' '}
                                                            {i}
                                                        </p>
                                                    )}
                                                    {i !== 0
                                                        && (
                                                            <div className="flex items-center cursor-pointer remove-creation" onClick={() => RemoveCriterion(i)}>
                                                                <img src="/images/IconfeatherTrash.svg" alt="icon" className="cursor-pointer" />
                                                                <span className="text-xs2 font-semibold text-[#ED1C24] pl-1.5">Delete Criterion</span>
                                                            </div>
                                                        )}
                                                </div>
                                                <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-3.5">
                                                    <div className="w-[90%]">
                                                        <div className="flex items-center justify-between">
                                                            <p className="text-[#090406] font-bold text-sm">Offer Parameter</p>
                                                            <div>
                                                                {i !== 0 && (
                                                                    <div className="border border-[#D8DDE3] rounded-[11px] flex items-center py-[15px] px-3">
                                                                        <p className="text-xs2 font-semibold text-[#555259] pr-4">Condition</p>
                                                                        <ul className="w-fit h-[24px] border border-[#D8DDE3] rounded-md nav nav-pills flex items-center bg-[#D8DDE3]" id="pills-tab1" role="tablist">
                                                                            <li className="nav-item w-[42px] text-center" role="presentation" onClick={() => handleCondition(i, 'AND')}>
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    className={item.condition === 'AND' ? 'nav-pills .nav-link.active block  text-sm font-semibold text-[#FFFFFF] bg-[#555259] and ml-[1px]' : 'nav-link block  text-sm font-semibold text-[#A1A1A1] and ml-[1px]'}
                                                                                    // className={`nav-link block  text-sm font-semibold text-[#A1A1A1] and ml-[1px] ${item.condition === 'AND' ? 'active' : ''}`}
                                                                                    id="pills-and-tab"
                                                                                    data-bs-toggle="pill"
                                                                                    data-bs-target="#pills-and"
                                                                                    role="tab"
                                                                                    aria-controls="pills-and"
                                                                                    aria-selected="true"
                                                                                >
                                                                                    AND
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item w-[42px] text-center" role="presentation" onClick={() => handleCondition(i, 'OR')}>
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    className={item.condition === 'OR' ? 'nav-pills .nav-link.active block  text-sm font-semibold text-[#FFFFFF] bg-[#555259] and ml-[1px]' : 'nav-link block  text-sm font-semibold text-[#A1A1A1] and ml-[1px]'}
                                                                                    // className={`nav-link block text-sm font-semibold text-[#A1A1A1] and mr-[1px] ${item.condition === 'OR' ? 'active' : ''}`}
                                                                                    id="pills-or-tab"
                                                                                    data-bs-toggle="pill"
                                                                                    data-bs-target="#pills-or"
                                                                                    role="tab"
                                                                                    aria-controls="pills-or"
                                                                                    aria-selected="false"
                                                                                >
                                                                                    OR
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="mt-5 flex">
                                                            <div className="w-[15%] px-3 flex justify-start">
                                                                <ul className="nav nav-pills flex border border-[#555259] rounded-[5px] h-[38px] w-fit" id="pills-tabVertical" role="tablist">
                                                                    <li
                                                                        className="nav-item flex-grow text-center"
                                                                        role="presentation"
                                                                        id="offer_parameter"
                                                                        value={criteria[i].offer_parameter}
                                                                        onClick={() => handleChangeToggle(i, '', 'quantity')}
                                                                    >
                                                                        <a href="#home3" className={criteria[i].offer_parameter === 'quantity' ? 'nav-link block active offer-currency2 font-semibold text-[#555259] text-xs20 w-[72px] rounded-[5px]' : 'nav-link block offer-currency2 font-bold text-[#555259] text-xs20 w-[72px] rounded-[5px]'} id="pill10" data-bs-toggle="pill" data-bs-target="#home10" role="tab" aria-controls="home10" aria-selected="true" style={{ lineHeight: '36px' }}>
                                                                            Quantity
                                                                        </a>
                                                                    </li>
                                                                    <li
                                                                        className="nav-item flex-grow text-center"
                                                                        role="presentation"
                                                                        id="offer_parameter"
                                                                        value={criteria[i].offer_parameter}
                                                                        onClick={() => handleChangeToggle(i, '', 'value')}
                                                                    >
                                                                        <a href="#home4" className={criteria[i].offer_parameter === 'value' ? 'nav-link block active offer-currency2 font-semibold text-[#555259] text-xs20 w-[72px] rounded-[5px]' : 'nav-link block offer-currency2 font-bold text-[#555259] text-xs20 w-[72px] rounded-[5px]'} id="pill4" data-bs-toggle="pill" data-bs-target="#home15" role="tab" aria-controls="home15" aria-selected="true" style={{ lineHeight: '36px' }}>
                                                                            Value
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            {criteria[i].offer_parameter === 'quantity'
                                                                ? (
                                                                    <div className="tab-content w-[30%] ml-[40px]" id="pills-tabContentVertical">
                                                                        <div className="tab-pane fade show active w-full" id="home10" role="tabpanel" aria-labelledby="pill10">
                                                                            <div className="flex">
                                                                                <div className="w-full px-[6px] relative">
                                                                                    <input
                                                                                        className={`border border-[#${submitSelected && item.minimum_quantity === '' ? 'ED1C24' : 'B1B4B7'}]  rounded-lg h-[50px] w-full relative p-3 outline-0`}
                                                                                        type="text"
                                                                                        id="minimum_quantity"
                                                                                        value={item.minimum_quantity}
                                                                                        onChange={(e) => {
                                                                                            InputCriteriaChange(e, i);
                                                                                            setsubmitSelected(false);
                                                                                        }}
                                                                                        autoComplete="off"
                                                                                        placeholder=""
                                                                                        onKeyDown={(e) => ['-'].includes(e.key) && e.preventDefault()}
                                                                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                    />
                                                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">
                                                                                        Minimum Quantity
                                                                                        {' '}
                                                                                        <span className="text-[#ED1C24]">*</span>
                                                                                    </p>
                                                                                    {submitSelected && item.minimum_quantity === '' && <span className="text-s font-light text-[#ED1C24]">Minimum quantity is required</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <p className="ml-[10px]">Based on the primary UOM of the item</p>
                                                                    </div>
                                                                ) : (
                                                                    <div className="tab-pane fade w-[30%] ml-[40px]" id="home15" role="tabpanel" aria-labelledby="pill4">
                                                                        <div className="flex">
                                                                            <div className="w-full px-[6px] relative">
                                                                                <input
                                                                                    className={`border border-[#${submitSelected && item.minimum_value === '' ? 'ED1C24' : 'B1B4B7'}] rounded-lg h-[50px] w-full relative p-3 outline-0`}
                                                                                    placeholder=""
                                                                                    type="text"
                                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                                    value={item.minimum_value}
                                                                                    id="minimum_value"
                                                                                    autoComplete="off"
                                                                                    onKeyDown={(e) => ['-'].includes(e.key) && e.preventDefault()}
                                                                                    onFocus={() => setsubmitSelected(false)}
                                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                />
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">
                                                                                    Minimum Value
                                                                                    {' '}
                                                                                    <span className="text-[#ED1C24]">*</span>
                                                                                </p>
                                                                                {submitSelected && item.minimum_value === '' && <span className="text-s font-light text-[#ED1C24]">Minimum value is required</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <div className="flex -mx-[6px] pt-8">
                                                            <div className="w-1/3 px-[6px]">
                                                                <div className={`border border-[#${submitSelected && item.trade_discount === '' ? 'ED1C24' : 'B1B4B7'}] rounded-lg h-[50px] w-full relative p-3`}>
                                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                                        Trade Discount
                                                                        {' '}
                                                                        <span className="text-[#ED1C24]">*</span>
                                                                    </p>
                                                                    <div className="flex">
                                                                        <div className="tab-content" id="pills-tabContentVertical">
                                                                            <div
                                                                                className="tab-pane fade show active"
                                                                                id="home1"
                                                                                role="tabpanel"
                                                                                aria-labelledby="pill1"
                                                                            >
                                                                                <input
                                                                                    type="text"
                                                                                    className={`w-full border-[#${submitSelected && item.trade_discount === '' ? 'ED1C24' : 'B1B4B7'}] font-normal text-lg text-[#000] outline-0 text-left`}
                                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                    maxLength={criteria[i].discount_parameter === 1 ? 5 : null}
                                                                                    id="trade_discount"
                                                                                    value={item.trade_discount}
                                                                                    autoComplete="off"
                                                                                />
                                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                                            </div>
                                                                            <div className="tab-pane fade" id="home2" role="tabpanel" aria-labelledby="pill2">
                                                                                <input type="text" className="w-full font-normal text-lg text-[#000] outline-0 text-right" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span className="text-s font-light text-[#ED1C24]">{criteria[i].trade_discount_error}</span>
                                                                {submitSelected && item.trade_discount === '' && <span className="text-s font-light text-[#ED1C24]">Trade Discount is required</span>}
                                                            </div>
                                                            <div className="w-1/3 px-[6px]">
                                                                <div className={`border border-[#${submitSelected && item.additional_discount === '' ? 'ED1C24' : 'B1B4B7'}] rounded-lg h-[50px] w-full relative p-3`}>
                                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                                        Additional Discount
                                                                        <span className="text-[#ED1C24]">*</span>
                                                                    </p>
                                                                    <div className="flex">
                                                                        <div className="tab-content" id="pills-tabContentVertical">
                                                                            <div
                                                                                className="tab-pane fade show active"
                                                                                id="home1"
                                                                                role="tabpanel"
                                                                                aria-labelledby="pill1"
                                                                            >
                                                                                <input
                                                                                    className="w-full font-normal text-lg text-[#000] outline-0 text-left"
                                                                                    type="text"
                                                                                    id="additional_discount"
                                                                                    autoComplete="off"
                                                                                    maxLength={criteria[i].discount_parameter === 1 ? 5 : null}
                                                                                    value={item.additional_discount}
                                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                    onFocus={() => setsubmitSelected(false)}
                                                                                />
                                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                                            </div>
                                                                            <div className="tab-pane fade" id="home2" role="tabpanel" aria-labelledby="pill2">
                                                                                <input type="text" className="w-full font-normal text-lg text-[#000] outline-0 text-right" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span className="text-s font-light text-[#ED1C24]">{criteria[i].additional_discount_error}</span>
                                                                {submitSelected && item.additional_discount === '' && <span className="text-s font-light text-[#ED1C24]">Additional Discount is required</span>}
                                                            </div>
                                                            <div className="w-1/3 px-[6px]">
                                                                <div className={`border border-[#${submitSelected && item.FIXED_CASHBACK === '' ? 'ED1C24' : 'B1B4B7'}] rounded-lg h-[50px] w-full relative p-3`}>
                                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                                        Fixed Discount
                                                                        <span className="text-[#ED1C24]">*</span>
                                                                    </p>
                                                                    <div className="flex">
                                                                        <div className="tab-content" id="pills-tabContentVertical">
                                                                            <div
                                                                                className="tab-pane fade show active"
                                                                                id="home1"
                                                                                role="tabpanel"
                                                                                aria-labelledby="pill1"
                                                                            >
                                                                                <input
                                                                                    className="w-full font-normal text-lg text-[#000] outline-0 text-left"
                                                                                    type="text"
                                                                                    id="FIXED_CASHBACK"
                                                                                    autoComplete="off"
                                                                                    value={item.FIXED_CASHBACK}
                                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                    onFocus={() => setsubmitSelected(false)}
                                                                                />
                                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                                            </div>
                                                                            <div className="tab-pane fade" id="home2" role="tabpanel" aria-labelledby="pill2">
                                                                                <input type="text" className="w-full font-normal text-lg text-[#000] outline-0 text-right" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span className="text-s font-light text-[#ED1C24]">{criteria[i].additional_discount_error}</span>
                                                                {submitSelected && item.FIXED_CASHBACK === '' && <span className="text-s font-light text-[#ED1C24]">Fixed Discount is required</span>}
                                                            </div>
                                                            <div className="w-1/3 px-[6px]">
                                                                <div className={`border border-[#${submitSelected && item.FULFILMENT_CASHBACK === '' ? 'ED1C24' : 'B1B4B7'}] rounded-lg h-[50px] w-full relative p-3`}>
                                                                    <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-2.5 bg-[#FFFFFF] px-1">
                                                                        Fullfillment Cashback *
                                                                        <span className="text-[#ED1C24]">*</span>
                                                                    </p>
                                                                    <div className="flex">
                                                                        <div className="tab-content" id="pills-tabContentVertical">
                                                                            <div
                                                                                className="tab-pane fade show active"
                                                                                id="home1"
                                                                                role="tabpanel"
                                                                                aria-labelledby="pill1"
                                                                            >
                                                                                <input
                                                                                    className="w-full font-normal text-lg text-[#000] outline-0 text-left"
                                                                                    type="text"
                                                                                    id="FULFILMENT_CASHBACK"
                                                                                    autoComplete="off"
                                                                                    value={item.FULFILMENT_CASHBACK}
                                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                                    onFocus={() => setsubmitSelected(false)}
                                                                                />
                                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                                            </div>
                                                                            <div className="tab-pane fade" id="home2" role="tabpanel" aria-labelledby="pill2">
                                                                                <input type="text" className="w-full font-normal text-lg text-[#000] outline-0 text-right" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span className="text-s font-light text-[#ED1C24]">{criteria[i].additional_discount_error}</span>
                                                                {submitSelected && item.FULFILMENT_CASHBACK === '' && <span className="text-s font-light text-[#ED1C24]">FULFILMENT Discount is required</span>}
                                                            </div>
                                                            {/* <div className="w-1/3 px-[6px] relative">
                                                            <div className="relative">
                                                                <input
                                                                    className="border border-[#D8DDE3] rounded-lg h-[50px] w-full relative p-3 outline-0 pl-8 text-right"
                                                                    placeholder=""
                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                    id="FIXED_CASHBACK"
                                                                    autoComplete="off"
                                                                    value={item.FIXED_CASHBACK}
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                    onFocus={() => setsubmitSelected(false)}
                                                                />
                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                            </div>
                                                            <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">
                                                                Fixed Cashback
                                                                {' '}
                                                                {' '}
                                                                <span className="text-[#ED1C24]">*</span>

                                                            </p>
                                                            {submitSelected && item.FIXED_CASHBACK === '' && <span className="text-s font-light text-[#ED1C24]">Fixed Cashback is required</span>}
                                                        </div>
                                                        <div className="w-1/3 px-[6px] relative">
                                                            <div className="relative">
                                                                <input
                                                                    className="border border-[#D8DDE3] rounded-lg h-[50px] w-full relative p-3 outline-0 pl-8 text-right"
                                                                    placeholder=""
                                                                    onChange={(e) => InputCriteriaChange(e, i)}
                                                                    id="FULFILMENT_CASHBACK"
                                                                    autoComplete="off"
                                                                    value={item.FULFILMENT_CASHBACK}
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, ''); }}
                                                                    onFocus={() => setsubmitSelected(false)}
                                                                />
                                                                <button type="button" className="absolute right-5 top-3">%</button>
                                                            </div>
                                                            <p className="text-xs2 font-semibold text-[#808285] absolute top-[-8px] left-4 bg-[#FFFFFF] px-1">
                                                                Fullfillment Cashback
                                                                {' '}
                                                                {' '}
                                                                <span className="text-[#ED1C24]">*</span>

                                                            </p>
                                                            {submitSelected && item.FULFILMENT_CASHBACK === '' && <span className="text-s font-light text-[#ED1C24]">Fullfillment Cashback is required</span>}
                                                        </div> */}
                                                        </div>
                                                        {(item.product_parameter !== undefined && item.product_parameter.length !== 0) && item.product_parameter.map((parameter, index) => (
                                                            <div className="" key={index}>
                                                                <div className="flex justify-between items-center">
                                                                    <p className="text-[#090406] font-bold text-sm py-8">Product Parameter</p>
                                                                    {index !== 0
                                                                        && (
                                                                            <div className="flex items-center cursor-pointer remove-creation" onClick={() => RemoveProductParameter(i, index)}>
                                                                                <img src="/images/IconfeatherTrash.svg" alt="icon" className="cursor-pointer" />
                                                                                <span className="text-xs2 font-semibold text-[#ED1C24] pl-1.5">Delete Product Parameter</span>
                                                                            </div>
                                                                        )}
                                                                </div>
                                                                <div className="flex -mx-1 mt-3.5 items-center">
                                                                    <div className="px-1 w-1/3">
                                                                        <div className="dropdown relative" onClick={() => handleCriteriatoggle(i, 'main_category', index)}>
                                                                            <button
                                                                                type="button"
                                                                                id="s1"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                className={`dropdown-to h-12 w-full rounded-lg outline-0 border border-[#${submitSelected && parameter.main_category === '' ? 'ED1C24' : 'B1B4B7'}] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left`}
                                                                            >
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                                                    Main Category
                                                                                    {' '}
                                                                                    <span className="text-[#ED1C24]">*</span>
                                                                                </p>
                                                                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                                                {parameter.main_category}
                                                                            </button>
                                                                            {submitSelected && parameter.main_category === '' && <span className="text-s font-light text-[#ED1C24]">Main Category is required</span>}
                                                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${(criteriaIndex === i && productParameterIndex === index && selectedEvent === 'main_category') ? '' : 'hidden'}`} aria-labelledby="m12">
                                                                                {mainCategory.map((main, mainKey) => (
                                                                                    <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={mainKey}>
                                                                                        <a className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)" onClick={() => handleSelectCategories('main_category', i, index, main.value)}>{main.value}</a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>

                                                                        </div>
                                                                    </div>
                                                                    <div className="px-1 w-1/3">
                                                                        <div className="dropdown relative">
                                                                            <button
                                                                                type="button"
                                                                                id="s1"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left"
                                                                                onClick={() => handleCriteriatoggle(i, 'category', index)}
                                                                            >
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                                                    Product Group
                                                                                </p>
                                                                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                                                {parameter.category}
                                                                            </button>
                                                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] ${(parameter.categoryList !== undefined && parameter.categoryList.length > 0) ? '' : 'hidden'} rounded-lg shadow-s2 z-[9999] ${(criteriaIndex === i && productParameterIndex === index && selectedEvent === 'category') ? '' : 'hidden'}`} aria-labelledby="m22" style={{ height: '100px', overflow: 'auto' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="search"
                                                                                    autoComplete="off"
                                                                                    value={search}
                                                                                    onChange={(e) => {
                                                                                        setSearch(e.target.value);
                                                                                    }}
                                                                                    className="w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg"
                                                                                    placeholder="Search"
                                                                                />
                                                                                {(parameter.categoryList !== undefined && parameter.categoryList.length !== 0) && parameter.categoryList.filter((value) => categorySearchHandler(value)).map((category) => (
                                                                                    <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={category?.CATEGORY_ID}>
                                                                                        <a
                                                                                            className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                                            href="javascript:void(0)"
                                                                                            onClick={() => handleSelectCategories('category', i, index, category.value)}
                                                                                        >
                                                                                            {category.value}
                                                                                        </a>
                                                                                    </li>
                                                                                ))}

                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="flex -mx-1 mt-3.5">
                                                                    <div className="px-1 w-1/3">
                                                                        <div className="dropdown relative">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleCriteriatoggle(i, 'subCategory1', index)}
                                                                                id="s1"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left"
                                                                            >
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                                                    Product Sub Group
                                                                                </p>
                                                                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                                                {parameter.subCategory1.length > 20
                                                                                    ? parameter.subCategory1.substring(0, 20) : parameter.subCategory1}
                                                                            </button>
                                                                            <ul className={`dropdown-menu w-full absolute${(parameter.subCategory1List !== undefined && parameter.subCategory1List.length > 0) ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${(criteriaIndex === i && productParameterIndex === index && selectedEvent === 'subCategory1') ? '' : 'hidden'}`} aria-labelledby="s121" style={{ height: '100px', overflow: 'auto' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="search"
                                                                                    autoComplete="off"
                                                                                    value={search}
                                                                                    onChange={(e) => {
                                                                                        setSearch(e.target.value);
                                                                                    }}
                                                                                    className="w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg"
                                                                                    placeholder="Search"
                                                                                />
                                                                                {(parameter.subCategory1List !== undefined && parameter.subCategory1List.length > 0) && parameter.subCategory1List.filter((value) => categorySearchHandler(value)).map((category1, cidx) => (
                                                                                    <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={cidx}>
                                                                                        <a
                                                                                            className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                                            href="javascript:void(0)"
                                                                                            onClick={() => handleSelectCategories('subCategory1', i, index, category1.value)}
                                                                                        >
                                                                                            {category1.value}

                                                                                        </a>
                                                                                    </li>
                                                                                ))}

                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <div className="px-1 w-1/3">
                                                                        <div className="dropdown relative">
                                                                            <button
                                                                                type="button"
                                                                                id="s1"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                onClick={() => handleCriteriatoggle(i, 'subCategory2', index)}
                                                                                className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left"
                                                                            >
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                                                    Product Sub Sub Group
                                                                                </p>
                                                                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                                                {(parameter.subCategory2List !== undefined && parameter.subCategory2.length > 20)
                                                                                    ? parameter.subCategory2.substring(0, 20) : parameter.subCategory2}
                                                                            </button>
                                                                            <ul className={`dropdown-menu w-full absolute ${(parameter.subCategory2List !== undefined && parameter.subCategory2List.length > 0) ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${(criteriaIndex === i && productParameterIndex === index && selectedEvent === 'subCategory2') ? '' : 'hidden'}`} aria-labelledby="s22" style={{ height: '100px', overflow: 'auto' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="search"
                                                                                    autoComplete="off"
                                                                                    value={search}
                                                                                    onChange={(e) => {
                                                                                        setSearch(e.target.value);
                                                                                    }}
                                                                                    className="w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg"
                                                                                    placeholder="Search"
                                                                                />
                                                                                {(parameter.subCategory2List !== undefined && parameter.subCategory2List.length > 0) && parameter.subCategory2List.filter((value) => categorySearchHandler(value)).map((category2, cidx) => (
                                                                                    <li className="pl-3.5 w-full pt-3 bg-[#ffffff]" key={cidx}>
                                                                                        <a
                                                                                            className="dropdown-item text-xs6 font-normal text-[#555259] w-full inline-block territory-inp"
                                                                                            href="javascript:void(0)"
                                                                                            onClick={() => handleSelectCategories('subCategory2', i, index, category2.value)}
                                                                                        >
                                                                                            {category2.value}

                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="-mx-1 mt-3.5">
                                                                    <div className="px-1 w-full">
                                                                        <div className="dropdown relative">
                                                                            <button
                                                                                type="button"
                                                                                id="s1"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                className="dropdown-to h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 text-left"
                                                                                onClick={() => { handleSelectCategories('products', i, index); setProductsDropdown(!productsDropdown); }}
                                                                            >
                                                                                <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                                                    Product(SKU)
                                                                                </p>
                                                                                <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                                                                {parameter.productStatus}
                                                                            </button>
                                                                            {productsDropdown
                                                                                && (
                                                                                    <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] overflow-auto h-[100px] ${(criteriaIndex === i && productParameterIndex === index && selectedEvent === 'products') && (parameter.products !== undefined && productList.length > 0) ? '' : 'hidden'}`} aria-labelledby="s1">
                                                                                        <input
                                                                                            type="text"
                                                                                            name="search"
                                                                                            autoComplete="off"
                                                                                            value={search}
                                                                                            onChange={(e) => {
                                                                                                setSearch(e.target.value);
                                                                                            }}
                                                                                            className="w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg"
                                                                                            placeholder="Search"
                                                                                        />
                                                                                        {(parameter.products !== undefined && parameter.products.length > 0) && parameter.products.filter((value) => productSearchHandler(value)).map((product, checkboxId) => (
                                                                                            <li
                                                                                                className="pl-3.5 w-full pt-3 bg-[#ffffff]"
                                                                                                key={`${i}${index}${checkboxId}`}
                                                                                            >
                                                                                                <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkboxls flex items-center">
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        id={`${i}${index}${checkboxId}`}
                                                                                                        onClick={(e) => {
                                                                                                            handleAddProduct(i, index, product, e);
                                                                                                        }}
                                                                                                        checked={handleCheckedIndex(i, index, product.INVENTORY_ITEM_ID)}
                                                                                                        className="cursor-pointer"
                                                                                                    />
                                                                                                    <label htmlFor={`${i}${index}${checkboxId}`} className="font-normal text-[#555259] text-xs2 pl-2 pr-10 cursor-pointer item1">
                                                                                                        {/* {product.MODEL_DESCRIPTION || product?.DESCRIPTION?.split(' ')[0]} */}
                                                                                                        {product.MODEL_DESCRIPTION || product?.DESCRIPTION?.length > 102 ? `${product.DESCRIPTION.substring(0, 102)}...` : product.DESCRIPTION}

                                                                                                        {' '}
                                                                                                        <span className="text-xs13">
                                                                                                            (
                                                                                                            {product.CONCATENATED_SEGMENTS}
                                                                                                            )
                                                                                                        </span>
                                                                                                    </label>
                                                                                                </div>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                )}
                                                                        </div>
                                                                        {criteria[i].product_parameter[index].selectedProducts.length > 0 && criteria[i].product_parameter[index].selectedProducts.map((prod) => (
                                                                            <div className="mt-4 options">
                                                                                <div className="flex">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={(e) => {
                                                                                            handleAddProduct(i, index, prod, e);
                                                                                        }}
                                                                                    >
                                                                                        <img src="/images/circle-close.svg" alt="icon" className="mr-2" />
                                                                                    </button>
                                                                                    <p className="text-[#090406] font-normal text-xs6">{prod.PRODUCT_NAME}</p>
                                                                                    {' - '}
                                                                                    <p className="text-[#090406] font-normal text-xs6">{prod.PRODUCT_DESCRIPTION}</p>
                                                                                    {' '}
                                                                                    <p className="text-[#090406] font-normal text-xs6">
                                                                                        (
                                                                                        {prod.CONCATENATED_SEGMENTS}
                                                                                        )
                                                                                    </p>
                                                                                </div>

                                                                            </div>
                                                                        ))}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleAddProductParameter(i)}
                                                                            className="text-sm font-semibold text-[#555259] mt-7 add-product-parameter cursor-pointer"
                                                                        >
                                                                            + Add Product Parameter

                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    ))}
                                    <div className="flex justify-center">
                                        <button
                                            type="button"
                                            onClick={() => handleCriterion()}
                                            className="my-2.5 w-[152px] h-[38px] bg-[#555259] text-xs6 font-bold text-[#FFFFFF] rounded-lg add-creation add-creation2"
                                        >
                                            Add Criterion
                                        </button>
                                    </div>
                                </div>
                                <div className="mt-4 mb-8 flex justify-center">
                                    <button disabled={loading} type="submit" className="w-[235px] h-[38px] bg-[#555259] text-xs6 font-bold text-[#FFFFFF] rounded-lg create-deal flex items-center justify-center">
                                        {loading ? <ThreeDotsLoader /> : isUpdate ? 'Update Offer' : 'Create Offer'}
                                    </button>
                                </div>
                            </form>

                        </div>
                        <div className={['filter-overlay ', (toggle.offer_type || toggle.type || toggle.start_date || toggle.end_date) ? 'filter-open' : ''].join('')} onClick={() => handleDropdownStatus()} />
                    </>
                )}
        </div>

    );
}
const mapState = (state) => {
    const { DistributorList } = state;
    return { DistributorList };
};
const createActors = {
    GetDistributorList: DistributorActions.DistributorList,
};
const connectCreateBulkOffer = connect(mapState, createActors)(CreateBulkOffer);

export { connectCreateBulkOffer as CreateBulkOffer };
